import { all, takeLatest } from 'redux-saga/effects'

import * as actions from './utils.actions'
import { fetchCurrentTimeSaga } from './sagas/fetch-current-time'

export default function* () {
  yield all([takeLatest(actions.FETCH_CURRENT_TIME_REQUEST, fetchCurrentTimeSaga)])
}
